import { h } from "omi";

import { IconProps } from "@/components";

export function MessageSquareIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 20 21">
      <path
        stroke="#344054"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.66667"
        d="M2.5 7.12109c0-1.40013 0-2.10019.27248-2.63497.23969-.47041.62214-.85286 1.09254-1.09254.53478-.27249 1.23485-.27249 2.63498-.27249h7c1.4001 0 2.1002 0 2.635.27249.4704.23968.8528.62213 1.0925 1.09254.2725.53478.2725 1.23484.2725 2.63497v4.50001c0 1.4001 0 2.1002-.2725 2.635-.2397.4704-.6221.8528-1.0925 1.0925-.5348.2725-1.2349.2725-2.635.2725H8.06979c-.52004 0-.78007 0-1.02878.051a2.499882 2.499882 0 0 0-.63477.2227c-.2261.1155-.42914.278-.83523.6028l-1.98788 1.5903c-.34674.2774-.52011.4161-.66601.4163-.1269.0001-.24693-.0576-.3261-.1568C2.5 18.2334 2.5 18.0114 2.5 17.5673V7.12109Z"
      />
    </svg>
  );
}
